import { render, staticRenderFns } from "./ReturnInvoiceSetting.vue?vue&type=template&id=5b005d9f&scoped=true&"
import script from "./ReturnInvoiceSetting.vue?vue&type=script&lang=js&"
export * from "./ReturnInvoiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReturnInvoiceSetting.vue?vue&type=style&index=0&id=5b005d9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b005d9f",
  null
  
)

export default component.exports